/* Mizori — predictive search (/search/suggest.json)
   Werkt op elk formulier met [data-predictive-search]: desktopheader én mobiele header.
   Bewust geen Section Rendering API: die geeft 401 op een wachtwoord-beveiligde store. */
(function () {
  'use strict';
  // Prijsopmaak volgt shop.money_format (via window.mzShop in layout/theme.liquid), niet een
  // hardcoded euroteken: anders liegt de zoeksuggestie zodra een markt een andere valuta krijgt.
  var SHOP = window.mzShop || {};
  var STRINGS = SHOP.strings || {};
  var FORMAT = SHOP.moneyFormat || '€{{amount_with_comma_separator}}';

  function groepeer(getal, duizend, decimaal, decimalen) {
    var vast = Math.abs(getal).toFixed(decimalen);
    var delen = vast.split('.');
    var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
    return decimalen > 0 && delen[1] ? heel + decimaal + delen[1] : heel;
  }

  function fmt(price) {
    var bedrag = parseFloat(price);
    if (isNaN(bedrag)) return '';
    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_m, sleutel) {
      switch (sleutel) {
        case 'amount_no_decimals': return groepeer(bedrag, ',', '.', 0);
        case 'amount_with_comma_separator': return groepeer(bedrag, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return groepeer(bedrag, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return groepeer(bedrag, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return groepeer(bedrag, ' ', ',', 0);
        case 'amount_with_space_separator': return groepeer(bedrag, ' ', ',', 2);
        case 'amount_with_period_and_space_separator': return groepeer(bedrag, ' ', '.', 2);
        default: return groepeer(bedrag, ',', '.', 2); // 'amount'
      }
    });
  }

  // Producttitels komen ongefilterd uit de API; zonder escapen breekt één & of < de hele lijst.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
    var input = form.querySelector('input[type=search]');
    var results = form.parentNode.querySelector('[data-search-results]');
    if (!input || !results) return;
    var min = parseInt(form.getAttribute('data-min') || '2', 10);
    var limit = parseInt(form.getAttribute('data-limit') || '8', 10);
    var zoekpagina = form.getAttribute('action') || '/search';
    // routes.predictive_search_url draagt het taalvoorvoegsel (/en/search/suggest). Een hardcoded
    // '/search/suggest.json' zoekt altijd in de primaire taal en geeft op /en dus Nederlandse titels.
    var suggestUrl = form.getAttribute('data-suggest-url') || '/search/suggest';
    var timer, controller, actief = -1;

    var rijen = function () { return Array.prototype.slice.call(results.querySelectorAll('[data-rij]')); };

    function open() { results.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function hide() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      actief = -1;
    }

    function markeer(i) {
      var lijst = rijen();
      lijst.forEach(function (el) { el.classList.remove('is-active'); });
      if (i >= 0 && i < lijst.length) {
        lijst[i].classList.add('is-active');
        lijst[i].scrollIntoView({ block: 'nearest' });
        actief = i;
      } else {
        actief = -1;
      }
    }

    function render(products, q) {
      if (!products.length) {
        results.innerHTML = '<div class="mz-search__empty">' + esc(STRINGS.no_results || 'Geen resultaten') + '</div>';
        actief = -1;
        open();
        return;
      }
      var html = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var prijs = fmt(p.price);
        if (p.available === false && STRINGS.sold_out) prijs = esc(STRINGS.sold_out);
        return '<a class="mz-search__result" data-rij href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="45" height="45" loading="lazy">' : '') +
          '<span class="mz-search__result-info"><span class="mz-search__result-title">' + esc(p.title) + '</span>' +
          '<span class="mz-search__result-price">' + prijs + '</span></span></a>';
      }).join('');
      // Zonder deze regel is de zoekpagina alleen via Enter bereikbaar en zie je nooit meer dan
      // de eerste 8 treffers — precies wat op shishatabak.nl/shishasmaak.nl wél kan.
      html += '<a class="mz-search__all" data-rij href="' + esc(zoekpagina) + '?q=' + encodeURIComponent(q) + '">' +
        esc(STRINGS.view_all_results || 'Alle resultaten bekijken') +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      results.innerHTML = html;
      actief = -1;
      open();
    }

    function zoek(q) {
      // Vorige vlucht afbreken: anders kan een traag antwoord op "ada" dat van "adalya" overschrijven.
      if (controller) controller.abort();
      controller = new AbortController();
      var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + limit + '&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () { /* afgebroken of netwerkfout: stil, paneel laten staan */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < min) { hide(); return; }
      timer = setTimeout(function () { zoek(q); }, 180);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); return; }
      if (results.hidden) return;
      var lijst = rijen();
      if (!lijst.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); markeer(actief + 1 >= lijst.length ? 0 : actief + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); markeer(actief - 1 < 0 ? lijst.length - 1 : actief - 1); }
      else if (e.key === 'Enter' && actief >= 0) { e.preventDefault(); lijst[actief].click(); }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= min && results.innerHTML) open();
    });

    document.addEventListener('click', function (e) { if (!form.parentNode.contains(e.target)) hide(); });
  });
})();
